import React, { useState, useContext } from "react";
import Header from '../shared/header';
import UserPool from "../UserPool";
import { CognitoUser } from "amazon-cognito-identity-js"
import './login.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from "./Account";
const ForgotPassword = () => {
    const { confirmPassword } = useContext(AccountContext)
    const [email, setEmail] = useState(sessionStorage.getItem("username"));
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    let navigate = useNavigate();
    const onSubmit = (event) => {
        event.preventDefault();
        if (code.trim().length === 0 || email.trim().length === 0 || password.trim().length === 0) {
            return;
        }
        confirmPassword(email, code, password).then(data => {
            toast.success('Password Changed', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            navigate("/login");
        })
            .catch(err => {
                toast.error('Invalid verification code provided, please try again.', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            })
    }

    return (
        <div>
            <Header isSignUp={false} />
            <div className="bg-img">
                <form onSubmit={onSubmit} className='main-div'>

                    <div className="margin-bottom-15">
                        <h3>Forgot Password</h3>
                    </div>
                    {/* {errorMessage} */}
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" className={email.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={email} onChange={(event) => setEmail(event.target.value)} placeholder="Enter email" />
                        <label for="validationError" class="form-label text-danger">{email.trim().length == 0 ? "email is required" : ""}</label>
                    </div>
                    <div className="form-group ">
                        <label>Code</label>
                        <input type="text" className={code.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={code} onChange={(event) => setCode(event.target.value)} placeholder="Enter confirmation code" />
                        <label for="validationError" class="form-label text-danger">{code.trim().length == 0 ? "code is required" : ""}</label>
                    </div>
                    <div className="form-group ">
                        <label>New Password</label>
                        <input type="password" className={password.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Enter password" />
                        <label for="validationError" class="form-label text-danger">{password.trim().length == 0 ? "password is required" : ""}</label>
                    </div>
                    <div class="o-form-button-bar"><input class="btn btn-primary" type="submit" value="Reset Password" id="reset-submit" data-type="save" /></div>
                </form>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
};

export default ForgotPassword;